export const ORIGIN = 'https://profile.present.me'
export const PDF_PARAMETER = 'animate=false'

export const UUID = window.location.pathname.slice(1)

export const IS_PDF = window.location.search.includes(PDF_PARAMETER)
